"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactApollo = require("react-apollo");
var _reactRouter = require("react-router");
var _commonLoader = require("@mmc/common-loader");
var _aboveTheFoldOnlyServerRender = require("above-the-fold-only-server-render");
var _calculationForm = _interopRequireDefault(require("./calculation-form"));
var _calculationForm2 = _interopRequireDefault(require("./calculation-form2"));
var _query = require("./query");
var _calculationForm3 = require("./calculation-form.utils");
var _commonSetLocation = require("@mmc/common-set-location");
var _commonLibs = require("@mmc/common-libs");
var _CommonLoader;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _CalculatorFormResolver = function CalculatorFormResolver(props) {
  var market = props.market,
    language = props.language,
    dataProp = props.data,
    _props$location$query = props.location.query,
    vehicle = _props$location$query.vehicle,
    paymentVehicle = _props$location$query.paymentVehicle,
    yearParam = _props$location$query.year,
    isBackgroundWhite = props.isBackgroundWhite;
  var _useState = (0, _react.useState)({
      zipCode: ''
    }),
    state = _useState[0],
    setState = _useState[1];
  (0, _react.useEffect)(function () {
    var cachedLocation = (0, _commonSetLocation.getCachedLocation)();
    if (cachedLocation && cachedLocation != null && cachedLocation.stateCode) {
      var code = {
        zipCode: cachedLocation == null ? void 0 : cachedLocation.stateCode
      };
      setState(_objectSpread(_objectSpread({}, state), code));
    }
    _commonLibs.EventEmitter.subscribe('locationChangeEvent', function (data) {
      var stateCode = data.stateCode;
      if (stateCode) {
        var _code = {
          zipCode: stateCode
        };
        setState(_objectSpread(_objectSpread({}, state), _code));
      }
    });
  }, []);
  var year = yearParam && Number(yearParam);
  var _useQuery = (0, _reactApollo.useQuery)(_query.PC_CONTENT_PAGE_QUERY_V2, {
      skip: !!dataProp,
      variables: _objectSpread(_objectSpread(_objectSpread({
        market: market,
        lang: language,
        // FIXME: Replace harcoded value with expected `path`
        path: language === 'en' ? '/content/mitsubishi-motors/ca/en/buy/payment-calculator' : '/content/mitsubishi-motors/ca/fr/acheter/calculateur-de-paiements'
      }, vehicle && {
        paymentVehicle: vehicle
      }), year && {
        paymentYear: year
      }), {}, {
        zipCode: state.zipCode
      })
    }),
    rawData = _useQuery.data,
    loading = _useQuery.loading;

  // Resolve Calculator v2
  if (market === 'ca') {
    // Make sure a vehicle has been selected, either on OGC/NGC or Payment Calculator
    if (!vehicle && !paymentVehicle) {
      return null;
    }

    // OGC compatible: Make sure ContentPage with `vehicles` is pulled
    var data = dataProp;
    if (!dataProp && rawData) {
      data = (0, _calculationForm3.getComponentPageDataByResourceType)(rawData, _CalculatorFormResolver.resourceType());
    }
    if (!dataProp && loading) {
      return _CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null));
    }
    return /*#__PURE__*/_react["default"].createElement(_aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender, {
      skip: true
    }, /*#__PURE__*/_react["default"].createElement(_calculationForm2["default"], (0, _extends2["default"])({
      data: data
    }, props, {
      isBackgroundWhite: isBackgroundWhite
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_calculationForm["default"], props);
};
_CalculatorFormResolver.displayName = 'CalculationForm';
_CalculatorFormResolver.resourceType = function () {
  return 'PaymentCalculator_1_0_0';
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language,
    path: props.path || state.Config.path
  };
};
var _default = exports["default"] = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(_CalculatorFormResolver));